import React, { FC } from 'react'
import { RouteComponentProps } from '@reach/router'
import { useIntl } from 'react-intl'
import { Heading, Box, Text } from 'grommet'

const NoSale: FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl()
  return (
    <div>
      <Heading textAlign="center">{formatMessage({ id: 'home.title' })}</Heading>
      <Box direction="row" gap="large" wrap justify="center">
        <Text size="huge">Aucune vente n'est en cours ...</Text>
      </Box>
      <Box direction="row" gap="large" wrap justify="center">
        <Text size="normal">Il semble qu'aucune vente live n'existe actuellement</Text>
      </Box>
    </div>
  )
}

export default NoSale
